import AbnAcnField from './AbnAcnField.component';

export default AbnAcnField;